export default __webpack_public_path__ + "static/jack-07dc8d40f7b542738982dedb33934180.png";